module.exports = __webpack_public_path__ + "static/media/navycross.636ba3b1.svg";